// services/dashboard.service.js
import fetchWithAuthRetry from "./fetchWithAuthRetry";
import { showMessage } from "../customhooks/useNotifier";

import environment from "../environments/environment";
const API_URL = environment.REACT_APP_BACKEND_API_BASE_URL;

const dashboardService = {
  getAllChatDetail: async () => {
    try {
      const response = await fetchWithAuthRetry(
        `${API_URL}/api/v1/chatwidget/allchatdetail`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch chat details");
      }

      return await response.json();
    } catch (err) {
      console.error("Dashboard error:", err);
      showMessage(err.message || "Something went wrong", "error");
      throw err;
    }
  },

  getAllChatUsers: async () => {
    try {
      const response = await fetchWithAuthRetry(
        `${API_URL}/api/v1/chatwidget/allchatusers`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch chat users");
      }

      return await response.json();
    } catch (err) {
      console.error("Dashboard error:", err);
      showMessage(err.message || "Something went wrong", "error");
      throw err;
    }
  },
};

export default dashboardService;
